export default "__VITE_ASSET__79a2ae7a__"